import toastr from 'toastr';
import * as Sentry from '@sentry/react';
import errorLoggingServerService from '../service/ErrorLoggingService';

class LogUtils {
  constructor() {
    this.errorLoggingService = errorLoggingServerService;
  }

  logMessageToLoggingServer = (message) => {
    this.errorLoggingService.logMessageToServer(message);
  };

  logError = (error, errorMessage) => {
    console.error(error);
    if (error.errors && error.errors.length > 0 && error.errors[0].errorType === 'CUSTOM_ERROR') {
      errorMessage = error.errors[0].message;
    }
    if (errorMessage) {
      toastr.error(errorMessage);
    }
    this.errorLoggingService.logExceptionToServer(error);
  };

  logAPIMessageToLoggingServer = (apiMessage) => {
    this.errorLoggingService.logBreadCrumbToServer({
      category: 'API',
      message: apiMessage,
      level: Sentry.Severity.Info,
    });
  };

  configureUserScopeInErrorLoggingService = (user) => {
    this.errorLoggingService.configureUserScope(user);
  };
}

const logUtils = new LogUtils();
export default logUtils;
